import { render } from "./commande.vue?vue&type=template&id=f8872d6a&scoped=true"
import script from "./commande.vue?vue&type=script&lang=js"
export * from "./commande.vue?vue&type=script&lang=js"

import "./commande.vue?vue&type=style&index=0&id=f8872d6a&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8872d6a"]])

export default __exports__